import { ProjectMember } from '@/domain/project/project-with-members.entity';

export default class ProjectDetail {
  id: string;

  name: string;

  description?: string;

  members: ProjectMember[];

  allowMandalaEditClosedVsts: boolean = false;

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.description = obj.description || '';
    this.members = (obj.members || []).map((member: any) => new ProjectMember(member));
    this.allowMandalaEditClosedVsts = obj.allowMandalaEditClosedVsts;
  }

  public static of(value: any): ProjectDetail {
    return new ProjectDetail(value || {});
  }

  public static ofList(response: any): ProjectDetail[] {
    return response.data.map(this.of);
  }
}
